import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { testimonials } from '@/mocks/site';

export default function VoiceSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="Readers"
          title="读者怎么说"
          desc="这些反馈来自公开评论与合作方的授权引用，我们只做了删减，没有改动原意。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-50 p-6 transition-colors hover:border-secondary-300"
            >
              <i className="ri-double-quotes-l text-xl text-secondary-500" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-sm font-bold text-accent-800">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center gap-4 rounded-lg bg-secondary-100 p-6 text-center md:flex-row md:justify-between md:p-8 md:text-left">
          <div>
            <h3 className="font-heading text-lg font-bold text-secondary-950">
              想知道我们为什么坚持「慢一点」？
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-secondary-900">
              在关于我们页面，我们完整交代了内容原则、核查标准与团队立场。
            </p>
          </div>
          <Link
            to="/about"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-secondary-700 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-800"
          >
            阅读我们的原则
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}